import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home'; // Adjust the path if necessary
import NotFoundPage from './pages/404'; // Ensure the correct path to 404.jsx
import Admin from './pages/Admin'; // Import the Admin page
import Form from './pages/Form'; // Import the Form page
import Faq from './pages/faq'; // Import the Faq page
import Portal from './pages/Portal'; // Import the Faq page
import BlogInfo from './components/blog/BlogInfo'; // Import BlogInfo
import Discord from './pages/Discord'; // Correctly import Discord.jsx

const App = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    let keyPressTimer;

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.altKey) {
                keyPressTimer = setTimeout(() => {
                    const password = prompt('Enter Admin Password:');
                    if (password === '290309') {
                        setIsAdmin(true);
                    } else {
                        alert('Incorrect Password. Access Denied.');
                    }
                }, 5000); // 5 seconds
            }
        };

        const handleKeyUp = () => {
            clearTimeout(keyPressTimer);
        };

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, []);

    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/join" element={<div>Join Page</div>} />
                <Route path="/discord" element={<Discord />} /> {/* Updated to use the Discord component */}
                <Route path="/user-agreements" element={<div>User Agreements Page</div>} />
                <Route path="/support" element={<div>Support Page</div>} />
                <Route path="/login" element={<div>Login/Register Page</div>} />
                <Route path="/admin" element={isAdmin ? <Admin /> : <NotFoundPage />} /> {/* Admin access control */}
                <Route path="/form" element={<Form />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/Portal" element={<Portal />} />
                <Route path="/blogs/:title" element={<BlogInfo />} />
                {/* Catch-all route for undefined routes */}
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Router>
    );
};

export default App;
